import React, { ReactNode, useRef } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogProps, Toolbar, IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

type Props = DialogProps & {
    children: ReactNode
}

const Modal: React.FC<Props> = ({ title, children, onClose, maxWidth, PaperProps, ...props }) => {
    const content = useRef();
    return (
        <Dialog
            {...props}
            maxWidth={maxWidth || false}
            TransitionProps={{ unmountOnExit: true }}
            PaperProps={{
                ...PaperProps,
                style: {
                    minHeight: 'calc(100vh - 64px)',
                    width: 900,
                    maxWidth: '100%',
                    ...PaperProps?.style,
                    overflowY: 'hidden',
                },
            }}
        >
            <Toolbar sx={{justifyContent: 'space-between'}}>
                <DialogTitle>{title}</DialogTitle>
                <IconButton
                    color={'inherit'}
                    onClick={(e) => onClose && onClose(e, 'escapeKeyDown')}
                    size="large">
                    <CloseIcon />
                </IconButton>
            </Toolbar>

            <DialogContent dividers ref={content}>{children}</DialogContent>
        </Dialog>
    );
}

export default Modal;
